import { manageGroup } from 'core/permissions';

export default {
  // @TODO manage group
  global: manageGroup,
  local: 'reporting.pivot_report_local',
  managed: 'reporting.pivot_report_local_managed',
};
